import React from "react";
import { duBois, haycock, mosteller, validate } from "./scRules";

const fr2 = (n) => (Math.round(n * 100) / 100).toFixed(2).replace(".", ",");
const num = (s) => parseFloat(String(s).replace(",", "."));
const inputCls = "py-2 w-20 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300";

function Field({ id, label, value, onChange, unit }) {
    return (
        <div>
            <label htmlFor={id} className="text-sm sm:text-base mb-2 block cursor-default">{label}</label>
            <div className="flex items-center gap-2">
                <input id={id} type="text" inputMode="decimal" placeholder="—" className={inputCls}
                    value={value} onChange={(e) => onChange(e.target.value.replace(/[^0-9.,]/g, ""))} />
                <span className="text-base sm:text-xl font-bold cursor-default">{unit}</span>
            </div>
        </div>
    );
}

function FormulaRow({ name, note, value }) {
    return (
        <div className="flex items-center justify-between bg-stone-100 rounded-lg px-4 py-2">
            <div><div className="font-semibold text-sm sm:text-base text-gray-900">{name}</div><div className="text-xs text-gray-600">{note}</div></div>
            <div className="font-bold text-base sm:text-lg text-emerald-800 shrink-0 ml-2">{value} m²</div>
        </div>
    );
}

export default function SurfaceCorporelle() {
    const [height, setHeight] = React.useState("");
    const [weight, setWeight] = React.useState("");
    const h = num(height), w = num(weight);
    const ok = validate({ height: h, weight: w });
    const ready = ok.height && ok.weight;

    return (
        <>
            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg flex flex-wrap gap-6">
                <Field id="sc-height" label="Taille" value={height} onChange={setHeight} unit="cm" />
                <Field id="sc-weight" label="Poids" value={weight} onChange={setWeight} unit="kg" />
            </div>
            {height && !ok.height && <p className="text-sm text-red-700 text-center mb-2">Taille à saisir en centimètres (entre 30 et 250).</p>}
            {weight && !ok.weight && <p className="text-sm text-red-700 text-center mb-2">Poids à saisir en kilogrammes (entre 0,5 et 300).</p>}

            {!ready ? (
                <div className="p-6 my-2 sm:my-4 bg-stone-50 border border-dashed border-stone-300 rounded-lg text-center">
                    <p className="text-gray-900 font-semibold text-sm sm:text-base">Renseignez la taille et le poids</p>
                    <p className="text-gray-600 text-sm mt-2">Vous obtiendrez la surface corporelle selon les formules de Mosteller, Du Bois et Haycock.</p>
                </div>
            ) : (
                <>
                    <div className="p-4 my-2 sm:my-4 rounded-lg w-full bg-gradient-to-b from-emerald-900 to-emerald-700 text-white text-center">
                        <div className="text-sm text-emerald-200">Surface corporelle (formule de Mosteller)</div>
                        <div className="text-4xl sm:text-5xl font-bold my-1">{fr2(mosteller(h, w))} <span className="text-xl font-semibold">m²</span></div>
                    </div>
                    <div className="mb-2 font-bold text-center w-full sm:text-lg cursor-default">Selon les différentes formules</div>
                    <div className="flex flex-col gap-2">
                        <FormulaRow name="Mosteller" note="√(taille × poids ÷ 3600), la plus utilisée" value={fr2(mosteller(h, w))} />
                        <FormulaRow name="Du Bois" note="Formule historique (1916)" value={fr2(duBois(h, w))} />
                        <FormulaRow name="Haycock" note="Validée chez l'enfant" value={fr2(haycock(h, w))} />
                    </div>
                    <p className="text-xs text-gray-600 mt-3">
                        Estimations à interpréter par un professionnel de santé. Ce calculateur ne calcule pas de posologie : les doses exprimées en mg/m² sont établies et vérifiées par le prescripteur et le pharmacien.
                    </p>
                </>
            )}
        </>
    );
}
